import React, { ReactNode, useState } from 'react';
import Highlighter from 'react-highlight-words';
import {
  IPopoverQuickLook,
  PopoverQuickLook,
} from '@src/emp-3.0/components/MappedEventDetail/QuickLook';

interface ILabelBuilder extends IPopoverQuickLook {
  event?: any;
  suffix?: ReactNode;
}

const LabelBuilder: React.FC<ILabelBuilder> = ({ event, suffix, quickLookProps, popoverProps }) => {
  const [labelMouseEnter, setLabelMouseEnter] = useState<boolean>(false);

  return (
    <PopoverQuickLook
      quickLookProps={{
        ...quickLookProps,
        name: event.name,
        id: event.id,
        type: typeof event.id !== 'undefined' ? 'mapped_event' : 'raw_event',
      }}
      popoverProps={{
        ...popoverProps,
        open: popoverProps?.open && labelMouseEnter,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          justifyContent: 'space-between',
        }}
        onMouseEnter={() => {
          setLabelMouseEnter(true);
        }}
        onMouseLeave={() => {
          setLabelMouseEnter(false);
        }}
      >
        <Highlighter
          autoEscape
          textToHighlight={event.name}
          highlightStyle={{
            mixBlendMode: 'darken',
            fontWeight: 500,
          }}
          searchWords={[quickLookProps?.searchText ?? '']}
        />
        {suffix}
      </div>
    </PopoverQuickLook>
  );
};

export default LabelBuilder;
